module.exports = __webpack_public_path__ + "static/img/3.672d3c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/2/eng/3.png
// module id = zGt2
// module chunks = 0